import React, { Component } from 'react';
import PropTypes from 'prop-types';

import shapes from '../../common/shapes';
import FormLoader from './FormLoader';

import './formClient.css';
import FormClientContent from './formClientContent';
import FormClientError from './formClientError';

class FormClient extends Component {
  componentDidMount() {
    const {
      formId,
      token,
      onFormClientInitialize
    } = this.props;

    onFormClientInitialize(formId, token);
  }

  handleFormSubmit = (form) => {
    const {
      token,
      onFormClientSubmit
    } = this.props;

    onFormClientSubmit(form, token);
  }

  handleLoginClick = () => {
    window.location.href = '/login';
  };

  render() {
    const {
      isInitializing,
      isSubmitting,
      isSubmitted,
      submitErrorMessage,
      teamName,
      userName,
      companyName,
      JSONSchema,
      UISchema,
      isError,
      headerImage,
      confirmationText,
      buttonLabel,
      buttonColor
    } = this.props;

    const content = isError
      ? (
        <FormClientError
          onLoginClick={this.handleLoginClick}
        />
      )
      : (
        <FormClientContent
          userName={userName}
          teamName={teamName}
          headerImage={headerImage}
          confirmationText={confirmationText}
          buttonLabel={buttonLabel}
          buttonColor={buttonColor}
          companyName={companyName}
          schema={JSONSchema}
          uiSchema={UISchema}
          onSubmit={this.handleFormSubmit}
          isSubmitting={isSubmitting}
          isSubmitted={isSubmitted}
          submitErrorMessage={submitErrorMessage}
        />
      );

    const template = isInitializing
      ? <FormLoader />
      : content;

    return (
      <div className="form-client">
        {template}
      </div>
    );
  }
}

FormClient.defaultProps = {
  teamName: '',
  userName: '',
  companyName: '',
  headerImage: '',
  confirmationText: '',
  buttonLabel: 'Submit',
  buttonColor: ''
};

FormClient.propTypes = {
  formId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  isInitializing: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  submitErrorMessage: PropTypes.string.isRequired,
  teamName: PropTypes.string,
  userName: PropTypes.string,
  headerImage: PropTypes.string,
  companyName: PropTypes.string,
  JSONSchema: PropTypes.shape(shapes.JSONSchema).isRequired,
  UISchema: PropTypes.shape(shapes.UISchema).isRequired,
  confirmationText: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonColor: PropTypes.string,
  onFormClientInitialize: PropTypes.func.isRequired,
  onFormClientSubmit: PropTypes.func.isRequired
};

export default FormClient;
